<div class="midia small-shadow border rounded" [ngStyle]="{ width: width + 'px' }">
    <mat-card>
        <ng-container *ngIf="file">
            <img
                *ngIf="imageFormats.includes(file.formato!.toLocaleLowerCase())"
                [src]="file.url"
                mat-card-image
                [ngStyle]="{ width: width - 1 + 'px', height: height + 'px' }"
                class="content-card"
            />
            <video
                class="content-card"
                mat-card-image
                [ngStyle]="{ width: width - 1 + 'px', height: height + 'px' }"
                controls
                *ngIf="videoFormats.includes(file.formato!.toLocaleLowerCase())"
            >
                <source [src]="file.url" />
            </video>
        </ng-container>
        <mat-card-content
            *ngIf="!file"
            class="content-card"
            [ngStyle]="{ width: '100%', height: height + 'px' }"
        >
            <div class="content-text" *ngIf="!salvandoMidia">Selecionar arquivo</div>
            <div *ngIf="salvandoMidia" class="content-text">
                <mat-spinner></mat-spinner>
                Carregando arquivo
            </div>
            <input (change)="changeFile($event)" type="file" class="input-file" />
        </mat-card-content>
        <mat-card-actions>
            <div class="d-flex justify-content-between">
                <button *ngIf="file" (click)="excluirMidia()" mat-button color="warn">
                    <mat-icon>delete</mat-icon>
                    Excluir arquivo
                </button>

                <div *ngIf="file?.posicao" class="d-flex justify-content-center align-items-center">
                    {{ file.posicao }}º
                </div>
            </div>
        </mat-card-actions>
    </mat-card>
</div>
